import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

interface Props extends LayoutDirection  {
  isOptionSelected: boolean;
}

export const useStyles = makeStyles(theme => ({
  cameFromOption: {
    transition: theme.transitions.create(['background-color']),
    backgroundColor: ({ isOptionSelected }: Props) => (isOptionSelected ? '#fff' : '#E1E4ED'),
    borderRadius: theme.spacing(2.5),
    padding: theme.spacing(9.5, 7.5),
    height: theme.spacing(30),
    width: '100%',
    maxWidth: theme.spacing(119),
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    flex: '1 0 calc(50% - 17px)',
    margin: theme.spacing(0, 0, 17, 0),

    '&:nth-child(odd)': {
      marginRight: ({ direction }: LayoutDirection) => direction === "rtl" ? 0 : theme.spacing(12.5),
      marginLeft: ({ direction }: LayoutDirection) => direction === "rtl" ? theme.spacing(12.5) : 0

      // margin: ({ direction }: LayoutDirection) => direction === "rtl" ? theme.spacing(0, 12.5, 17, 0): theme.spacing(0, 12.5, 17, 0),
    },

    '& .MuiTypography-root': {
      color: theme.palette.grey['500'],
      fontSize: theme.spacing(8),
      lineHeight: '21px',
    },
    '& .MuiButtonBase-root': {
      padding: 'unset',
      visibility: 'hidden',
      '&.Mui-checked': {
        visibility: 'visible',
      },
    },

    [theme.breakpoints.down('md')]: {
      flexBasis: '100%',
      maxWidth: 'unset',
    },
  },
}));
